if (!customElements.get('min-cart-gift')) {
  customElements.define('min-cart-gift', class MinCartGift extends HTMLElement {
    constructor() {
      super();
      this.closeBanner = this.closeBanner.bind(this);
    }

    connectedCallback() {
      if (sessionStorage.getItem('min_cart_gift_closed') === 'true') {
        this.classList.add('is-hidden');
        this.remove();
        return;
      }

      const closeButton = this.querySelector('.js-min-cart-gift-close');
      if (closeButton) {
        closeButton.addEventListener('click', this.closeBanner);
      }
    }

    disconnectedCallback() {
      const closeButton = this.querySelector('.js-min-cart-gift-close');
      if (closeButton) {
        closeButton.removeEventListener('click', this.closeBanner);
      }
    }

    closeBanner(event) {
      if (event) event.preventDefault();
      sessionStorage.setItem('min_cart_gift_closed', 'true');
      this.classList.add('is-hidden');
      this.remove();
    }
  });
}
